import GeoActionTypes from './geo.types';

export const setGeoDataStart = () => ({
  type: GeoActionTypes.SET_GEO_DATA_START
});

export const setGeoDataSuccess = (data) => ({
  type: GeoActionTypes.SET_GEO_DATA_SUCCESS,
  payload: data
});
export const setGeoDataFailure = (error) => ({
  type: GeoActionTypes.SET_GEO_DATA_FAILURE,
  payload: error
});
